import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=fd85a3ea&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=fd85a3ea&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=fd85a3ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd85a3ea",
  null
  
)

export default component.exports